import { useCallback } from "react";
import { Clients, useQuery } from "../apollo";
import { SearchUsersQuery } from "../graphql/queries/searchUsers";
import {
  AWSRegions,
  ExtendedUserSearchResponse,
  UserSearchFilterKeys,
  UserSearchInput,
} from "../generated/ups/graphql";
import { DEFAULT_REGION } from "../constants/regions";

type SearchUsersResponseType = {
  searchUsers: ExtendedUserSearchResponse;
};

type UserSearchInputType = {
  userSearch: UserSearchInput;
};

export const useSearchUserByEmail = () => {
  const query = useQuery<SearchUsersResponseType, UserSearchInputType>(
    Clients.UPS,
    SearchUsersQuery,
    {
      skip: true,
    },
  );

  const refetch = useCallback(
    async (email: string, region: AWSRegions = DEFAULT_REGION) => {
      return query.refetch({
        userSearch: {
          filter: {
            key: UserSearchFilterKeys.email,
            value: email,
          },
          page: {
            limit: 1,
            cursorToken: null,
          },
          region,
        },
      });
    },
    [query],
  );

  return {
    ...query,
    refetch,
  };
};
